import React from "react";
import "../GalleryComponent/GalleryComponentCss/NariShaktiSection.css";

import img1 from "../Images/nari1.jpg";   // top left
import img2 from "../Images/nari2.jpg";   // top middle
import img3 from "../Images/nari3.jpg";   // top right
import img4 from "../Images/nari4.png";   // bottom left
import img5 from "../Images/nari5.jpg";   // bottom right

export default function NariShaktiSection() {
  return (
    <section className="nari-shakti-wrapper">
      <h2 className="nari-title">नारीशक्ती गौरव पुरस्कार</h2>

      <div className="nari-grid">
        <div className="row row-top">
          <img src={img1} alt="" className="nari-photo" />
          <img src={img2} alt="" className="nari-photo" />
          <img src={img3} alt="" className="nari-photo" />
        </div>

        <div className="row row-bottom">
          <img src={img4} alt="" className="nari-photo bottom-photo" />
          <img src={img5} alt="" className="nari-photo bottom-photo" />
        </div>
      </div>
    </section>
  );
}
